// import React, { useState } from "react";
// import { Navbar, Nav, Offcanvas, Button } from "react-bootstrap";

// const Sidebar = () => {
//   const [show, setShow] = useState(false);

//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);

//   return (
//     <div>
//       {/* Navbar with Toggle Button */}
//       <Navbar bg="dark" variant="dark" className="p-3">
//         <Button variant="outline-light" onClick={handleShow}>
//           ☰ Menu
//         </Button>
//       </Navbar>

//       {/* Sidebar (Offcanvas) */}
//       <Offcanvas show={show} onHide={handleClose} backdrop="true">
//         <Offcanvas.Header closeButton>
//           <Offcanvas.Title>Sidebar Menu</Offcanvas.Title>
//         </Offcanvas.Header>
//         <Offcanvas.Body>
//           <Nav className="flex-column">
//             <Nav.Link href="#" onClick={handleClose}>
//               🏠 Home
//             </Nav.Link>
//             <Nav.Link href="#" onClick={handleClose}>
//               ℹ️ About
//             </Nav.Link>
//             <Nav.Link href="#" onClick={handleClose}>
//               📦 Items
//             </Nav.Link>
//           </Nav>
//         </Offcanvas.Body>
//       </Offcanvas>
//     </div>
//   );
// };

// export default Sidebar;

import React, { useState } from "react";
import {
  Navbar,
  Nav,
  Offcanvas,
  Button,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import "../style/Sidebar.css"; // Add custom CSS for better styling

const Sidebar = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div>
      {/* Navbar - Only visible on mobile & tablet */}
      <Navbar bg="dark" variant="dark" className="d-md-none p-3">
        <Button variant="outline-light" onClick={handleShow}>
          c Menu
        </Button>
      </Navbar>

      <Container fluid>
        <Row>
          {/* Sidebar - Always visible on large screens (hidden on mobile/tablet) */}
          <Col
            md={3}
            lg={2}
            className="d-none d-md-block sidebar bg-dark text-white"
          >
            <Nav className="flex-column p-3">
              <h4>Sidebar</h4>
              <Nav.Link href="#" className="text-white">
                🏠 Home
              </Nav.Link>
              <Nav.Link href="#" className="text-white">
                ℹ️ About
              </Nav.Link>
              <Nav.Link href="#" className="text-white">
                📦 Items
              </Nav.Link>
            </Nav>
          </Col>

          {/* Main Content Area */}
          <Col xs={12} md={9} lg={10} className="p-4">
            <h2>Welcome to the Page</h2>
            <p>This is the main content section.</p>
          </Col>
        </Row>
      </Container>

      {/* Offcanvas Sidebar - For Mobile/Tablet */}
      <Offcanvas show={show} onHide={handleClose} className="d-md-none">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Sidebar Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column">
            <Nav.Link href="#" onClick={handleClose}>
              🏠 Home
            </Nav.Link>
            <Nav.Link href="#" onClick={handleClose}>
              ℹ️ About
            </Nav.Link>
            <Nav.Link href="#" onClick={handleClose}>
              📦 Items
            </Nav.Link>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default Sidebar;
